import { useState } from 'react';

export const useGoogleMapsScript = () => {
  const API_KEY = 'AIzaSyC4ZkPZk_ksi_V-GH-L-1HA00Y6Xy6EEYk'; // prod key

  const [scriptHasLoaded, setScriptHasLoaded] = useState(false);

  return { scriptHasLoaded, setScriptHasLoaded, API_KEY };
};
